"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_RECEIVABLE_PERMISSIONS = exports.ReceivablePermissions = void 0;
/**
 * Permission string catalog for the Accounts Receivable bounded
 * context (Stage 13, Milestone 2 Part 1). Format `<module>:<action>`,
 * same convention as every sibling catalog. A new sibling file, not an
 * extension of `finance-accounting.permissions.ts` — matches how
 * `financial.permissions.ts` and `finance-accounting.permissions.ts`
 * were kept separate rather than merged. Role shape (Receivable
 * Manager/Cashier/Finance Manager/Auditor/Read Only) is expressed by
 * which of these a tenant's admin grants to which `Role`, not
 * hard-coded here — the same "roles are tenant-configurable,
 * permissions are the only code-level concept" posture every other
 * bounded context in this codebase takes.
 */
exports.ReceivablePermissions = {
    /** createInvoice. */
    RECEIVABLE_INVOICE_CREATE: 'receivable:invoice:create',
    /** writeOff — OPEN/PARTIALLY_PAID only. */
    RECEIVABLE_INVOICE_WRITE_OFF: 'receivable:invoice:write-off',
    /** cancelInvoice — OPEN with zero allocations only. */
    RECEIVABLE_INVOICE_CANCEL: 'receivable:invoice:cancel',
    /** allocate, allocateAutomatically, resolveOverpayment. */
    RECEIVABLE_ALLOCATION_MANAGE: 'receivable:allocation:manage',
    /** Invoice listing/read, AR Ledger, Outstanding, Ageing, GL drill-down. */
    RECEIVABLE_LEDGER_READ: 'receivable:ledger:read',
    /** placeHold, releaseHold. */
    RECEIVABLE_CREDIT_HOLD_MANAGE: 'receivable:credit-hold:manage',
    /** issueCreditNote (now HTTP-exposed for the first time). */
    RECEIVABLE_CREDIT_NOTE_ISSUE: 'receivable:credit-note:issue',
    /** issueDebitNote (now HTTP-exposed for the first time). */
    RECEIVABLE_DEBIT_NOTE_ISSUE: 'receivable:debit-note:issue',
};
/** Every Receivable permission, flattened — used to seed the `permissions` table. */
exports.ALL_RECEIVABLE_PERMISSIONS = Object.values(exports.ReceivablePermissions);
//# sourceMappingURL=receivable.permissions.js.map